// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"673f825a","977":"5bcea552"}[chunkId] + ".chunk.js";
};